
(function() {
  var result = { translations: { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.1015"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1015",
    "ar-eg": "static-7.1015",
    "bg": "static-7.1015",
    "bn": "static-7.1015",
    "ca-es": "static-7.1015",
    "cs": "static-7.1015",
    "da": "static-7.1015",
    "de": "static-7.1015",
    "el": "static-7.1015",
    "en-gb": "static-7.1015",
    "en": "static-7.1015",
    "es-mx": "static-7.1015",
    "es": "static-7.1015",
    "fi": "static-7.1015",
    "fr-ca": "static-7.1015",
    "fr": "static-7.1015",
    "he-il": "static-7.1015",
    "hr": "static-7.1015",
    "hu": "static-7.1015",
    "id": "static-7.1015",
    "it": "static-7.1015",
    "ja": "static-7.1015",
    "ko": "static-7.1015",
    "lt": "static-7.1015",
    "ms": "static-7.1015",
    "nl": "static-7.1015",
    "no": "static-7.1015",
    "pl": "static-7.1015",
    "pt-br": "static-7.1015",
    "pt-pt": "static-7.1015",
    "ro": "static-7.1015",
    "ru": "static-7.1015",
    "sk": "static-7.1015",
    "sl": "static-7.1015",
    "sv": "static-7.1015",
    "th": "static-7.1015",
    "tl": "static-7.1015",
    "tr": "static-7.1015",
    "uk": "static-7.1015",
    "vi": "static-7.1015",
    "x-pseudo": "static-7.1015",
    "zh-cn": "static-7.1015",
    "zh-hk": "static-7.1015",
    "zh-tw": "static-7.1015"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.1015'}); }
})();


